import moment from 'moment';

/**	 ❤时❤间❤格❤式❤转❤换
 *
 *   YY_MM_DD()   年-月-日
 *   YY_MM_DD_HH_TT()   年-月-日 时:分
 *   YY_MM_DD_HH_TT_SS()   年-月-日 时:分:秒
 *   HH_TT_SS()   时:分:秒
 **/

// YY-MM-DD   年-月-日 (不传默认当天)
export function YY_MM_DD(time) {
    return moment(time).format('YYYY-MM-DD');
}

// YY-MM-DD HH:TT   年-月-日 时:分 (不传默认当天)
export function YY_MM_DD_HH_TT(time) {
    return moment(time).format('YYYY-MM-DD HH:mm');
}

// YY-MM-DD HH:TT:SS   年-月-日 时:分:秒 (不传默认当天)
export function YY_MM_DD_HH_TT_SS(time) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
}

// YY-MM-DD HH:TT:SS   时:分:秒 (不传默认当天)
export function HH_TT_SS(time) {
    return moment(time).format('HH:mm:ss');
}
